const About = () => {
  return (
    <div className="container mt-5">
      <p> The project developed using TMDB API</p>
      <p>Used Technologies</p>
      <ul>
        <li>Htm</li>
        <li>CSS</li>
        <li>JavaScript</li>
        <li>Styled-components</li>
        <li>React</li>
        <li>Redux</li>
        <li>React Router Dom</li>
        <li>React Persist</li>
        <li>React-Query</li>
      </ul>
    </div>
  );
};
export default About;
